import store from '../store/store';
import type { ExtendedPalette } from '../store/schema/ExtendedTheme';

export default function getPalette(): Partial<ExtendedPalette> {
    return store().palette || {};
}
